import React from 'react';

function ClientsHomepage() {
    return (
        <section className="relative overflow-hidden bg-black bg-opacity-60">
            <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
                <div className="py-12 md:py-14 border-t border-gray-800 border-opacity-60" data-aos-id-clients>
                    {/* Section header */}
                    <div className="max-w-3xl mx-auto text-center">
                        <p className="text-xs font-semibold tracking-widest text-gray-400 mb-2">
                            IN PARTNERSHIP WITH
                        </p>
                        <div className="mx-auto h-1 w-20 rounded-full bg-gradient-to-r from-blue-500 via-purple-500 to-green-400" />
                        <p className="mt-4 text-sm sm:text-base text-gray-300">
                            Trusted by insurers, technology partners and innovation programmes across Europe.
                        </p>
                    </div>

                    {/* Partner logos */}
                    <div className="mt-10 grid gap-4 sm:grid-cols-3 md:grid-cols-4">
                        {/* ESA */}
                        <div
                            className="group flex h-24 sm:h-24 md:h-28 items-center justify-center rounded-2xl bg-white border border-gray-800 shadow-md transform transition duration-300 ease-out hover:-translate-y-1 hover:shadow-xl"
                            data-aos="fade-up"
                            data-aos-delay="100"
                            data-aos-anchor="[data-aos-id-clients]"
                        >
                            <img
                                className="max-h-20 w-auto"
                                src={require('../images/Logo/esa-logo.svg').default}
                                alt="European Space Agency"
                            />
                        </div>

                        {/* Sony */}
                        <div
                            className="group flex h-24 sm:h-24 md:h-28 items-center justify-center rounded-2xl bg-white border border-gray-800 shadow-md transform transition duration-300 ease-out hover:-translate-y-1 hover:shadow-xl"
                            data-aos="fade-up"
                            data-aos-delay="100"
                            data-aos-anchor="[data-aos-id-clients]"
                        >
                            <img
                                className="max-h-10 w-auto"
                                src={require('../images/Logo/sony-logo-black-and-white.png').default}
                                alt="Sony"
                            />
                        </div>

                        {/* Cicor */}
                        <div
                            className="group flex h-24 sm:h-24 md:h-28 items-center justify-center rounded-2xl bg-white border border-gray-800 shadow-md transform transition duration-300 ease-out hover:-translate-y-1 hover:shadow-xl"
                            data-aos="fade-up"
                            data-aos-delay="150"
                            data-aos-anchor="[data-aos-id-clients]"
                        >
                            <img
                                className="max-h-20 w-auto"
                                src={require('../images/Logo/Cicor_Logo_Standard_Screen.jpg').default}
                                alt="Cicor"
                            />
                        </div>

                        {/* Track */}
                        <div
                            className="group flex h-24 sm:h-24 md:h-28 items-center justify-center rounded-2xl bg-white border border-gray-800 shadow-md transform transition duration-300 ease-out hover:-translate-y-1 hover:shadow-xl"
                            data-aos="fade-up"
                            data-aos-anchor="[data-aos-id-clients]"
                        >
                            <img
                                className="max-h-10 w-auto"
                                src={require('../images/Logo/track.png').default}
                                alt="Track"
                            />
                        </div>

                        {/* EU RDF */}
                        <div
                            className="group flex h-24 sm:h-24 md:h-28 items-center justify-center rounded-2xl bg-white border border-gray-800 shadow-md transform transition duration-300 ease-out hover:-translate-y-1 hover:shadow-xl"
                            data-aos="fade-up"
                            data-aos-delay="200"
                            data-aos-anchor="[data-aos-id-clients]"
                        >
                            <img
                                className="max-h-20 w-auto"
                                src={require('../images/Logo/eurdf.png').default}
                                alt="European Regional Development Fund"
                            />
                        </div>

                        {/* Aspinity */}
                        <div
                            className="group flex h-24 sm:h-24 md:h-28 items-center justify-center rounded-2xl bg-white border border-gray-800 shadow-md transform transition duration-300 ease-out hover:-translate-y-1 hover:shadow-xl"
                            data-aos="fade-up"
                            data-aos-delay="200"
                            data-aos-anchor="[data-aos-id-clients]"
                        >
                            <img
                                className="max-h-15 w-auto"
                                src={require('../images/Logo/Aspinity_high_res_gray_logo.jpg').default}
                                alt="Aspinity"
                            />
                        </div>

                        {/* Roedan */}
                        <div
                            className="group flex h-24 sm:h-24 md:h-28 items-center justify-center rounded-2xl bg-white border border-gray-800 shadow-md transform transition duration-300 ease-out hover:-translate-y-1 hover:shadow-xl"
                            data-aos="fade-up"
                            data-aos-anchor="[data-aos-id-clients]"
                        >
                            <img
                                className="max-h-32 w-auto"
                                src={require('../images/Logo/roedan_logo_small@2x.png').default}
                                alt="Roedan"
                            />
                        </div>

                        {/* Innovate UK */}
                        <div
                            className="group flex h-24 sm:h-24 md:h-28 items-center justify-center rounded-2xl bg-white border border-gray-800 shadow-md transform transition duration-300 ease-out hover:-translate-y-1 hover:shadow-xl"
                            data-aos="fade-up"
                            data-aos-delay="150"
                            data-aos-anchor="[data-aos-id-clients]"
                        >
                            <img
                                className="max-h-20 w-auto"
                                src={require('../images/Logo/InnovateUK.png').default}
                                alt="Innovate UK"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ClientsHomepage;